var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"app-title"},[_c('em-view-title',{ref:"view-title",attrs:{"crudState":"cardList"}})],1),_c('section',{staticClass:"app-content"},[_c('div',{staticClass:"card-columns"},_vm._l((this.routerCards),function(cardData){return _c('EmCardRouter',{key:cardData.id,attrs:{"cardData":cardData}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }